// import { Link } from "react-router-dom";
// import { ArrowRight, Briefcase, UserCheck, RefreshCw, FileText, Users, ChevronRight } from "lucide-react";

// export default function StaffingSolutions() {
//   const solutions = [
//     {
//       title: "Permanent Staffing",
//       description: "Build long-term teams with committed professionals who align with your culture and business goals.",
//       link: "/permanent-staffing",
//       icon: Users,
//       color: "#0058a9",
//       gradient: "linear-gradient(135deg, #0058a9 0%, #1a7bc1 100%)",
//       lightBg: "#e8f2fa"
//     },
//     {
//       title: "Contract Staffing",
//       description: "Short-term talent solutions for project-based needs and peak workloads.",
//       link: "/contract-staffing",
//       icon: Briefcase,
//       color: "#0d9488",
//       gradient: "linear-gradient(135deg, #0d9488 0%, #14b8a6 100%)",
//       lightBg: "#f0fdfa"
//     },
//     {
//       title: "Direct Hire",
//       description: "Find permanent talent that fits your company's culture and long-term vision.",
//       link: "/direct-hire",
//       icon: UserCheck,
//       color: "#dc2626",
//       gradient: "linear-gradient(135deg, #dc2626 0%, #ef4444 100%)",
//       lightBg: "#fef2f2"
//     },
//     {
//       title: "Contract-to-Hire",
//       description: "Evaluate talent on the job before committing to a full-time hire.",
//       link: "/contract-to-hire",
//       icon: RefreshCw,
//       color: "#ea580c",
//       gradient: "linear-gradient(135deg, #ea580c 0%, #f97316 100%)",
//       lightBg: "#fff7ed"
//     },
//     {
//       title: "Statement of Work (SOW)",
//       description: "Deliverable-based staffing services with defined project scopes and milestones.",
//       link: "/sow",
//       icon: FileText,
//       color: "#7c3aed",
//       gradient: "linear-gradient(135deg, #7c3aed 0%, #8b5cf6 100%)",
//       lightBg: "#f5f3ff"
//     },
//   ];

//   return (
//     <section className="w-full py-20 md:py-28 lg:py-32  relative overflow-visible" style={{backgroundColor:'#001534'}}>
//       {/* Subtle Background Pattern */}
//       <div className="absolute inset-0 opacity-[0.02] pointer-events-none">
//         <div className="absolute top-0 right-0 w-96 h-96 bg-blue-600 rounded-full blur-3xl" />
//         <div className="absolute bottom-0 left-0 w-96 h-96 bg-purple-600 rounded-full blur-3xl" />
//       </div>

//       <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 relative z-10">
//         <div className="grid lg:grid-cols-2 gap-12 lg:gap-16">
          
//           {/* Left Content */}
//           <div>
//             <h2 
//               className="text-4xl md:text-5xl font-semibold leading-tight mb-4"
//               style={{ fontFamily: 'Outfit, sans-serif', color: '#ffffff' }}
//             >
//               Flexible IT Staffing Solutions for{' '}
//               <span className="relative inline-block">
//                 Every Business Need
//               </span>
//             </h2>
//             <p className="text-gray-600 text-lg mb-10 leading-relaxed" style={{ fontFamily: "'Open Sans', sans-serif", color:'#ffffff' }}>
//               Tailored workforce solutions designed to scale with your business, 
//               from permanent placements to project-based engagements.
//             </p>

//             <div className="space-y-4">
//               {solutions.map((solution, index) => (
//                 <Link
//                   key={index}
//                   to={solution.link}
//                   className="group block"
//                 >
//                   <div 
//                     className="flex items-start gap-5 p-5 rounded-2xl bg-white "
//                     style={{
//                       boxShadow: '0 1px 3px rgba(0,0,0,0.02)',
//                       transition: 'box-shadow 0.3s ease-out, border-color 0.3s ease-out, transform 0.3s ease-out'
//                     }}
//                     onMouseEnter={(e) => {
//                       e.currentTarget.style.boxShadow = `0 20px 35px -12px ${solution.color}20`;
//                       e.currentTarget.style.borderColor = `${solution.color}20`;
//                     }}
//                     onMouseLeave={(e) => {
//                       e.currentTarget.style.boxShadow = '0 1px 3px rgba(0,0,0,0.02)';
//                       e.currentTarget.style.borderColor = '#f3f4f6';
//                     }}
//                   >
//                     {/* Icon Container with Gradient */}
//                     <div className="relative flex-shrink-0">
//                       <div 
//                         className="absolute inset-0 rounded-xl blur-md opacity-40 transition-opacity duration-300 group-hover:opacity-70"
//                         style={{ background: solution.gradient }}
//                       />
//                       <div 
//                         className="relative p-3 rounded-xl transition-transform duration-300 group-hover:scale-110"
//                         style={{ background: solution.lightBg }}
//                       >
//                         <solution.icon className="w-6 h-6" style={{ color: solution.color }} />
//                       </div>
//                     </div>

//                     {/* Text Content */}
//                     <div className="flex-grow">
//                       <div className="flex items-center justify-between flex-wrap gap-2">
//                         <h4 
//                           className="text-lg font-semibold transition-colors duration-300"
//                           style={{ fontFamily: 'Outfit, sans-serif', color: '#081120' }}
//                         >
//                           {solution.title}
//                         </h4>
//                         <div 
//                           className="flex items-center gap-1 text-sm font-medium transition-all duration-300 opacity-0 group-hover:opacity-100 transform translate-x-[-8px] group-hover:translate-x-0"
//                           style={{ color: solution.color }}
//                         >
//                           <span>Learn More</span>
//                           <ChevronRight className="w-4 h-4" />
//                         </div>
//                       </div>
//                       <p className="text-md mt-1.5 leading-relaxed" style={{ fontFamily: "'Open Sans', sans-serif", color: '#6b7280' }}>
//                         {solution.description}
//                       </p>
                      
//                       {/* Hover Progress Bar */}
//                       <div 
//                         className="mt-3 h-[2px] w-0 bg-gradient-to-r rounded-full transition-all duration-500 group-hover:w-full"
//                         style={{ background: solution.gradient }}
//                       />
//                     </div>
//                   </div>
//                 </Link>
//               ))}
//             </div>

//             {/* CTA Button */}
//             {/* <div className="mt-10 pt-4">
//               <Link
//                 to="/services"
//                 className="inline-flex items-center gap-3 px-8 py-4 rounded-xl font-semibold text-base transition-all duration-300 hover:translate-y-[-2px] hover:shadow-xl group"
//                 style={{
//                   background: '#005FA3',
//                   color: 'white',
//                   fontFamily: "'Open Sans', sans-serif"
//                 }}
//               >
//                 Explore All Solutions
//                 <ArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-1" />
//               </Link>
//             </div> */}
//           </div>

//           {/* Right Side - Enhanced Image Section */}
//           <div className="relative">
//             <div className="sticky top-24">
              
//               {/* Decorative Elements */}
//               <div className="absolute -top-6 -right-6 w-32 h-32 bg-gradient-to-br from-[#0058a9]/10 to-transparent rounded-full blur-2xl" />
//               <div className="absolute -bottom-6 -left-6 w-40 h-40 bg-gradient-to-tr from-[#7c3aed]/10 to-transparent rounded-full blur-2xl" />

//               {/* Main Image Card */}
//               <div className="relative rounded-xl overflow-hidden shadow-2xl group">
                
//                 {/* Hover Overlay */}
//                 <div className="absolute inset-0 bg-gradient-to-t from-[#081120]/20 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500 z-10" />

//                 <img
//                   src="https://ik.imagekit.io/7wqj9br0b/KapilTech_Website_Staffing/Home/staffingimage2.png"
//                   alt="Flexible Staffing Solutions"
//                   className="w-full h-[380px] md:h-[500px] object-cover transition-all duration-700"
//                 />
//               </div>

//             </div>
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// }

import { Link } from "react-router-dom";
import { Briefcase, UserCheck, RefreshCw, FileText, Users, ChevronRight } from "lucide-react";

const solutions = [
    {
      title: "Permanent Staffing",
      description: "Build long-term teams with committed professionals who align with your culture and business goals.",
      link: "/services/staffing-services/permanent-staffing",
      icon: Users,
      color: "#0058a9",
      gradient: "linear-gradient(135deg, #0058a9 0%, #1a7bc1 100%)",
      lightBg: "#e8f2fa"
    },
    {
      title: "Contract Staffing",
      description: "Short-term talent solutions for project-based needs and peak workloads.",
      link: "/services/staffing-services/contract-staffing",
      icon: Briefcase,
      color: "#0d9488",
      gradient: "linear-gradient(135deg, #0d9488 0%, #14b8a6 100%)",
      lightBg: "#f0fdfa"
    },
    {
      title: "Direct Hire",
      description: "Find permanent talent that fits your company's culture and long-term vision.",
      link: "/services/staffing-services/direct-hire",
      icon: UserCheck,
      color: "#dc2626",
      gradient: "linear-gradient(135deg, #dc2626 0%, #ef4444 100%)",
      lightBg: "#fef2f2"
    },
    {
      title: "Contract-to-Hire",
      description: "Evaluate talent on the job before committing to a full-time hire.",
      link: "/services/staffing-services/contract-to-hire",
      icon: RefreshCw,
      color: "#ea580c",
      gradient: "linear-gradient(135deg, #ea580c 0%, #f97316 100%)",
      lightBg: "#fff7ed"
    },
    {
      title: "Statement of Work (SOW)",
      description: "Deliverable-based staffing services with defined project scopes and milestones.",
      link: "/services/staffing-services/statement-of-work",
      icon: FileText,
      color: "#7c3aed",
      gradient: "linear-gradient(135deg, #7c3aed 0%, #8b5cf6 100%)",
      lightBg: "#f5f3ff"
    },
  ];

export default function StaffingSolutions() {

  return (
    <section className="w-full py-20 md:py-24 lg:py-16 bg-white relative overflow-visible">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
        {/* Centered Header Section */}
        <div className="text-center max-w-3xl mx-auto mb-14">
          <h2 
            className="text-4xl md:text-5xl font-semibold leading-tight mb-4"
            style={{ fontFamily: 'Outfit, sans-serif', color: '#001534', lineHeight: "1.3" }}
          >
            Flexible IT Staffing Solutions for{' '}
            <span className="relative inline-block">
              Every Business Need
            </span>
          </h2>
          <p className="text-lg md:text-xl mb-0 leading-relaxed" style={{ fontFamily: '"Open Sans", sans-serif', color:'#4B5563', hyphens:'none', textAlign: 'center' }}>
            Tailored workforce solutions designed to scale with your business, 
            from permanent placements to project-based engagements.
          </p>
        </div>

        {/* Two Column Grid */}
        <div className="grid lg:grid-cols-2 gap-10 lg:gap-16 items-center">
          
          {/* Left Content - Solutions List */}
          <div>
            <div className="space-y-4">
              {solutions.map((solution, index) => (
                <Link
                  key={index}
                  to={solution.link}
                  className="group block"
                >
                  <div
                    className="relative overflow-hidden flex items-center gap-5 p-5 rounded-lg bg-[#F8FAFC] border border-[#E5EAF1] transition-all duration-300 group-hover:bg-white group-hover:-translate-y-1"
                    style={{
                      boxShadow: '0 10px 24px rgba(0, 21, 52, 0.06)',
                      borderLeft: `4px solid ${solution.color}`
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.boxShadow = `0 18px 34px -16px ${solution.color}80`;
                      e.currentTarget.style.borderColor = `${solution.color}40`;
                      e.currentTarget.style.borderLeftColor = solution.color;
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.boxShadow = '0 10px 24px rgba(0, 21, 52, 0.06)';
                      e.currentTarget.style.borderColor = '#E5EAF1';
                      e.currentTarget.style.borderLeftColor = solution.color;
                    }}
                  >
                    {/* Icon Container with Gradient */}
                    <div className="relative flex-shrink-0">
                      <div
                        className="absolute inset-0 rounded-lg blur-md opacity-30 transition-opacity duration-300 group-hover:opacity-50"
                        style={{ background: solution.gradient }}
                      />
                      <div
                        className="relative p-3 rounded-lg transition-transform duration-300 group-hover:scale-105"
                        style={{ background: solution.lightBg }}
                      >
                        <solution.icon className="w-6 h-6" style={{ color: solution.color }} />
                      </div>
                    </div>

                    {/* Text Content */}
                    <div className="flex-grow min-w-0">
                      <div className="flex items-center justify-between gap-3">
                        <h4 
                          className="text-lg font-semibold transition-colors duration-300 truncate"
                          style={{ fontFamily: 'Outfit, sans-serif', color: '#081120' }}
                        >
                          {solution.title}
                        </h4>
                        <div 
                          className="flex items-center gap-1 text-sm font-semibold transition-all duration-300 opacity-0 group-hover:opacity-100 transform translate-x-[-8px] group-hover:translate-x-0 shrink-0"
                          style={{ color: solution.color }}
                        >
                          <span>Learn More</span>
                          <ChevronRight className="w-4 h-4" />
                        </div>
                      </div>
                      {/* Hover Progress Bar */}
                      <div 
                        className="absolute bottom-0 left-0 h-[3px] w-0 transition-all duration-500 group-hover:w-full"
                        style={{ background: solution.gradient }}
                      />
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          </div>

          {/* Right Side - Enhanced Image Section */}
          <div className="relative">
            <div className="sticky top-24">
              <div className="relative rounded-lg overflow-hidden border border-[#E5EAF1] shadow-[0_24px_60px_rgba(0,21,52,0.14)] group">
                {/* Hover Overlay */}
                <div className="absolute inset-0 bg-gradient-to-t from-[#001534]/10 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500 z-10" />

                <img
                  src="https://ik.imagekit.io/7wqj9br0b/KapilTech_Website_Staffing/Home/staffingimage2.png"
                  alt="Flexible Staffing Solutions"
                  className="w-full h-[380px] md:h-[500px] object-cover transition-all duration-700"
                />
              </div>

            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
